/* START_MODULE_CONTRACT
 * PURPOSE: React-контекст состояния desktop sidebar (navCollapsed) для страниц Outlet.
 * SCOPE: SidebarLayoutProvider, useSidebarLayout.
 * DEPENDS: M-FE-LAYOUT
 * LINKS: M-FE-LAYOUT, M-FE-TIMELINE, UC-018
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * SidebarLayoutProvider - провайдер navCollapsed.
 * useSidebarLayout - хук чтения navCollapsed.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-28 - UC-018: публикация navCollapsed для ширины label-столбца таймлайна.
 * END_CHANGE_SUMMARY
 */

import { createContext, useContext, useMemo } from 'react';

const SidebarLayoutContext = createContext({ navCollapsed: false });

/* START_METHOD_SidebarLayoutProvider */
/* START_CONTRACT: SidebarLayoutProvider
 * PURPOSE: Провайдер состояния свёрнутости desktop sidebar для дочерних страниц.
 * INPUTS: { navCollapsed: boolean, children: ReactNode }.
 * OUTPUTS: { JSX.Element - SidebarLayoutContext.Provider }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-LAYOUT, UC-018
 * END_CONTRACT: SidebarLayoutProvider
 */
export function SidebarLayoutProvider({ navCollapsed = false, children }) {
  const value = useMemo(
    () => ({ navCollapsed: Boolean(navCollapsed) }),
    [navCollapsed],
  );

  return (
    <SidebarLayoutContext.Provider value={value}>
      {children}
    </SidebarLayoutContext.Provider>
  );
}
/* END_METHOD_SidebarLayoutProvider */

/* START_METHOD_useSidebarLayout */
/* START_CONTRACT: useSidebarLayout
 * PURPOSE: Прочитать navCollapsed из SidebarLayoutContext.
 * INPUTS: нет.
 * OUTPUTS: { { navCollapsed: boolean } }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-LAYOUT, UC-018
 * END_CONTRACT: useSidebarLayout
 */
export function useSidebarLayout() {
  return useContext(SidebarLayoutContext);
}
/* END_METHOD_useSidebarLayout */
